import { render, staticRenderFns } from "./CheckboxBooleanValue.vue?vue&type=template&id=637b56f5&"
import script from "./CheckboxBooleanValue.vue?vue&type=script&lang=js&"
export * from "./CheckboxBooleanValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports